/**
 * collection.js — نغمة ستور
 * تحسين تدريجي (Progressive Enhancement) حقيقي فقط لصفحة المجموعة. المحتوى
 * والفلاتر والفرز كلها تعمل بلا هذا الملف إطلاقًا عبر نموذج GET عادي
 * (action="{{ collection.url }}") وزر "تطبيق" حقيقي — انظر
 * sections/main-collection-product-grid.liquid وcomponent-collection.css
 * (لا يوجد hidden ثابت في Liquid إطلاقًا؛ صنف .no-js/.js وCSS المصاحب هما
 * من يقرران الظهور الافتراضي، وهذا الملف يضيف السمة hidden فعليًا فوق ذلك
 * فقط حين يعمل بنفسه فعلاً).
 *
 * تصحيحات جولة v3 (بعد رفض v2):
 * 1) syncDrawersForViewport() أصبحت كاملة فعليًا عند الانتقال لسطح المكتب:
 *    تُلغي أي closeTimer معلَّق، تُزيل is-open وhidden عن اللوحة، تُخفي
 *    الخلفية (Backdrop)، تُصفِّر aria-expanded على كل زر فتح، تُزيل أي
 *    Focus Trap نشط لتلك اللوحة، وتُنفِّذ Naghmah.unlockScroll() — قبل هذا
 *    التصحيح كان الانتقال لسطح المكتب أثناء فتح اللوحة على الجوال يترك
 *    الخلفية الداكنة والقفل وFocus Trap عالقين، ثم عند العودة للجوال قد
 *    تظهر الخلفية وحدها بلا اللوحة نفسها.
 * 2) دور Dialog الحقيقي: على الجوال فقط، عند فتح اللوحة فعليًا، تُضاف
 *    role="dialog" وaria-modal="true" وaria-label (من data-dialog-label
 *    المُعرَّب في Liquid) — لأن اللوحة على الجوال نافذة منبثقة حقيقية تحجب
 *    ما خلفها. على سطح المكتب هي Sidebar عادية ضمن تدفق الصفحة، فهذه
 *    السمات تُزال تمامًا (لا معنى لـDialog على عنصر ثابت غير منبثق).
 * 3) كل عناصر التحكم تُبحَث ضمن أقرب [data-collection-root] للعنصر الذي
 *    أُطلِق منه الحدث، لا عبر document.getElementById بمعرّف ثابت — يدعم
 *    أكثر من نسخة من main-collection-product-grid في نفس الصفحة.
 * 4) lastTrigger وremoveFocusTrap حالة خاصة بكل Drawer (WeakMap).
 * 5) تغيير الفرز عبر form.requestSubmit() مع fallback إلى form.submit().
 */
(function () {
  "use strict";

  var desktopQuery = window.matchMedia("(min-width: 990px)");
  var drawerState = typeof WeakMap === "function" ? new WeakMap() : null;
  var globalListenersBound = false;

  function getState(drawer) {
    if (drawerState) {
      var s = drawerState.get(drawer);
      if (!s) {
        s = { removeFocusTrap: null, lastTrigger: null };
        drawerState.set(drawer, s);
      }
      return s;
    }
    if (!drawer._naghmahFiltersState) {
      drawer._naghmahFiltersState = { removeFocusTrap: null, lastTrigger: null };
    }
    return drawer._naghmahFiltersState;
  }

  function getRoot(el) {
    return el.closest("[data-collection-root]");
  }

  function getDrawerFromRoot(root) {
    return root ? root.querySelector("[data-collection-filters]") : null;
  }

  function getBackdropFromRoot(root) {
    return root ? root.querySelector("[data-collection-filters-backdrop]") : null;
  }

  function setToggleButtonsExpanded(root, expanded) {
    if (!root) return;
    root.querySelectorAll("[data-collection-filters-toggle]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
  }

  /**
   * على الجوال فقط: اللوحة نافذة منبثقة حقيقية تحجب ما خلفها، فتحتاج دور
   * Dialog كاملاً (role + aria-modal + تسمية حقيقية). على سطح المكتب هي
   * Sidebar ثابتة ضمن تدفق الصفحة نفسه — لا معنى لهذه السمات هناك.
   */
  function applyDialogAttrs(drawer) {
    if (!drawer) return;
    drawer.setAttribute("role", "dialog");
    drawer.setAttribute("aria-modal", "true");
    var label = drawer.dataset.dialogLabel;
    if (label) {
      drawer.setAttribute("aria-label", label);
    }
  }

  function clearDialogAttrs(drawer) {
    if (!drawer) return;
    drawer.removeAttribute("role");
    drawer.removeAttribute("aria-modal");
    drawer.removeAttribute("aria-label");
  }

  function openDrawer(trigger) {
    var root = getRoot(trigger);
    var drawer = getDrawerFromRoot(root);
    if (!drawer) return;
    // اللوحة تُفتَح كـDrawer فقط على الجوال أصلاً (زر الفتح مخفي على سطح
    // المكتب عبر CSS)، لكن نتحقق دفاعيًا هنا أيضًا لمنع أي استدعاء برمجي
    // خاطئ من تفعيل سلوك Dialog/القفل على سطح المكتب.
    if (desktopQuery.matches) return;

    var backdrop = getBackdropFromRoot(root);
    var state = getState(drawer);

    if (drawer.closeTimer) {
      window.clearTimeout(drawer.closeTimer);
      drawer.closeTimer = null;
    }

    drawer.removeAttribute("hidden");
    if (backdrop) backdrop.removeAttribute("hidden");
    // إعادة تدفق (reflow) قبل إضافة صنف الفتح حتى يعمل الانتقال (transition).
    void drawer.offsetWidth;
    drawer.classList.add("is-open");
    state.lastTrigger = trigger || state.lastTrigger;

    setToggleButtonsExpanded(root, true);
    applyDialogAttrs(drawer);

    Naghmah.lockScroll();
    state.removeFocusTrap = Naghmah.trapFocus(drawer);
  }

  function closeDrawer(drawer) {
    if (!drawer || drawer.hasAttribute("hidden")) return;
    var root = getRoot(drawer);
    var backdrop = getBackdropFromRoot(root);
    var state = getState(drawer);

    drawer.classList.remove("is-open");
    setToggleButtonsExpanded(root, false);
    clearDialogAttrs(drawer);

    Naghmah.unlockScroll();
    if (state.removeFocusTrap) {
      state.removeFocusTrap();
      state.removeFocusTrap = null;
    }

    if (backdrop) backdrop.setAttribute("hidden", "");

    if (drawer.closeTimer) {
      window.clearTimeout(drawer.closeTimer);
    }
    drawer.closeTimer = window.setTimeout(function () {
      // لا تُخفَ اللوحة إن أصبح العرض سطح مكتب أثناء انتظار الانتقال (نادر
      // لكن ممكن أثناء تغيير حجم النافذة) — الـSidebar الثابتة لا تُغلَق.
      if (!desktopQuery.matches) {
        drawer.setAttribute("hidden", "");
      }
      drawer.closeTimer = null;
    }, 220); // يطابق --transition-base في design-tokens.css
  }

  function closeAndRestoreFocus(drawer) {
    if (!drawer) return;
    var state = getState(drawer);
    var lastTrigger = state.lastTrigger;
    var root = getRoot(drawer);
    closeDrawer(drawer);
    var returnTo = lastTrigger || (root && root.querySelector("[data-collection-filters-toggle]"));
    if (returnTo) returnTo.focus();
  }

  /**
   * مزامنة كاملة لحالة كل نسخ لوحة الفلاتر في الصفحة مع نقطة التوقف
   * الحالية — يغطي الانتقال في كلا الاتجاهين بلا أي أثر عالق.
   *
   * إلى سطح المكتب: اللوحة تصبح Sidebar ثابتة ضمن التدفق. يجب إلغاء كل
   * سلوك خاص بوضع الجوال بشكل صريح — إلغاء closeTimer، إزالة hidden وis-
   * open، إخفاء الخلفية، تصفير aria-expanded، إزالة سمات Dialog، فكّ أي
   * Focus Trap نشط، وفكّ قفل تمرير الصفحة — وإلا يبقى أثر (خلفية داكنة
   * عالقة، تمرير مقفول، تركيز محبوس) حتى بعد أن أصبحت اللوحة سطح مكتب.
   *
   * إلى الجوال: إن لم تكن مفتوحة فعليًا (is-open)، تُضمَن حالة الإغلاق
   * الافتراضية (hidden على اللوحة والخلفية معًا، aria-expanded=false) —
   * يمنع بقاءها ظاهرة بالخطأ بعد تصغير النافذة من سطح مكتب لجوال.
   */
  function syncDrawersForViewport() {
    document.querySelectorAll("[data-collection-filters]").forEach(function (drawer) {
      var root = getRoot(drawer);
      var backdrop = getBackdropFromRoot(root);
      var state = getState(drawer);

      if (desktopQuery.matches) {
        if (drawer.closeTimer) {
          window.clearTimeout(drawer.closeTimer);
          drawer.closeTimer = null;
        }
        drawer.removeAttribute("hidden");
        drawer.classList.remove("is-open");
        clearDialogAttrs(drawer);
        setToggleButtonsExpanded(root, false);

        if (backdrop) backdrop.setAttribute("hidden", "");

        if (state.removeFocusTrap) {
          state.removeFocusTrap();
          state.removeFocusTrap = null;
        }
        Naghmah.unlockScroll();
        state.lastTrigger = null;
      } else if (!drawer.classList.contains("is-open")) {
        drawer.setAttribute("hidden", "");
        if (backdrop) backdrop.setAttribute("hidden", "");
        setToggleButtonsExpanded(root, false);
      }
    });
  }

  function bindGlobalListenersOnce() {
    if (globalListenersBound) return;
    globalListenersBound = true;

    document.addEventListener("click", function (evt) {
      var toggle = evt.target.closest("[data-collection-filters-toggle]");
      if (toggle) {
        openDrawer(toggle);
        return;
      }
      var closeTrigger = evt.target.closest("[data-collection-filters-close]");
      if (closeTrigger) {
        closeAndRestoreFocus(getDrawerFromRoot(getRoot(closeTrigger)));
        return;
      }
      var backdrop = evt.target.closest("[data-collection-filters-backdrop]");
      if (backdrop) {
        closeAndRestoreFocus(getDrawerFromRoot(getRoot(backdrop)));
      }
    });

    document.addEventListener("keydown", function (evt) {
      if (evt.key !== "Escape") return;
      document.querySelectorAll("[data-collection-filters].is-open").forEach(function (drawer) {
        closeAndRestoreFocus(drawer);
      });
    });

    // تحسين تدريجي اختياري: إرسال النموذج تلقائيًا عند تغيير الفرز، عبر
    // requestSubmit() كي يحترم التحقق الأصلي للمتصفح (مثل حقلي السعر
    // number) بدل تجاوزه — form.submit() القديم كان يتجاوز هذا التحقق.
    document.addEventListener("change", function (evt) {
      var select = evt.target.closest("[data-collection-sort-select]");
      if (!select) return;
      var form = select.closest("form");
      if (!form) return;
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });

    if (typeof desktopQuery.addEventListener === "function") {
      desktopQuery.addEventListener("change", syncDrawersForViewport);
    } else if (typeof desktopQuery.addListener === "function") {
      // دعم احتياطي لمتصفحات أقدم لا تدعم addEventListener على MediaQueryList.
      desktopQuery.addListener(syncDrawersForViewport);
    }
  }

  function initSection() {
    bindGlobalListenersOnce();
    // يُستدعى أيضًا عند كل تحميل/إعادة تحميل قسم من محرر الثيم، فيُطبَّق
    // على أي نسخة جديدة من اللوحة أُضيفت للتو (تضيف hidden برمجيًا على
    // الجوال إن لم تكن مفتوحة — النموذج نفسه بلا JS يبقى ظاهرًا دومًا).
    syncDrawersForViewport();
  }

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;

  if (Naghmah.registerSection) {
    Naghmah.registerSection("main-collection-product-grid", initSection);
  }

  Naghmah.onReady(initSection);
})();
